import { render } from "./ProcedureApplication.vue?vue&type=template&id=1727d3ca&scoped=true"
import script from "./ProcedureApplication.vue?vue&type=script&lang=js"
export * from "./ProcedureApplication.vue?vue&type=script&lang=js"

import "./ProcedureApplication.vue?vue&type=style&index=0&id=1727d3ca&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1727d3ca"]])

export default __exports__